/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function getGroups(data) {
  var groupProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'group';
  var groupsConfig = data.reduce(function (acc, item, index) {
    var groupTitle = item[groupProperty];
    var currentGroup = acc.groups[acc.currentGroup];
    if (groupTitle && groupTitle !== (currentGroup && currentGroup.title)) {
      var newGroup = {
        title: groupTitle,
        indexAjustment: acc.indexAjustment + 1
      };
      var groupIndex = index + acc.indexAjustment;
      acc.groups[groupIndex] = newGroup;
      acc.currentGroup = groupIndex;
      acc.indexAjustment += 1;
    }
    return acc;
  }, {
    groups: {},
    currentGroup: 0,
    indexAjustment: 0
  });
  return groupsConfig.groups;
}
var _default = getGroups;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/ComboBox/src/utils/getGroups.js
// module id = 662
// module chunks = 0